import { Button, Card, Spinner } from 'react-bootstrap'
import { useAvvisi } from '../../hooks/interventi'
import { useNavigate } from 'react-router-dom'

export default function Avvisi() {
  const { data, isLoading } = useAvvisi()
  const navigate = useNavigate()
  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h1 className="title">Avvisi</h1>
        </div>
      </div>
      <div className="row mt-4">
        {isLoading ? (
          <Spinner />
        ) : (
          data?.map((avviso) => (
            <div key={avviso.id} className="col-md-4 mb-3">
              <Card>
                <Card.Header>Intervento non completato</Card.Header>
                {avviso.stato === 'programmato' && (
                  <Card.Body>
                    L'intervento con #{avviso.id} risulta completo ma non
                    inviato a un supervisore.
                  </Card.Body>
                )}
                {avviso.stato === 'eseguito' && avviso.esito_riesame === '' && (
                  <Card.Body>
                    L'intervento con #{avviso.id} risulta completato ma non
                    revisionato.
                  </Card.Body>
                )}
                {avviso.stato === 'eseguito' && avviso.esito_riesame !== '' && (
                  <Card.Body>
                    L'intervento con #{avviso.id} ha il riesame compilato ma
                    non ancora certificato.
                  </Card.Body>
                )}
                <Card.Footer className="d-flex justify-content-end">
                  <Button
                    variant="secondary"
                    className="text-white"
                    onClick={() => {
                      // Handle the action, e.g., navigate to detail page or show modal
                      navigate(`/interventi/${avviso.id}`)
                    }}
                  >
                    Dettaglio Intervento
                  </Button>
                </Card.Footer>
              </Card>
            </div>
          ))
        )}
        {data && data.length === 0 && (
          <div className="col-12">
            <p className="text-center">Nessun avviso disponibile.</p>
          </div>
        )}
      </div>
    </div>
  )
}
